import React from "react";
import { useSelector } from "react-redux";
import { ReactComponent as BoltIcon } from "assets/icons/bolt.svg";
import CountUp from "react-countup";
import usePreviousPersistent from "hooks/usePreviousPersistent";
import { motion } from "framer-motion";
import { gridContainerVariants } from "../ProductGrid";
import { selectUserProgress } from "store/game/selectors";
import { gridSlotVariants } from "../ProductGrid/GridSlot";

export default function UserProgress() {
  const { remainingHealth, score, health } = useSelector(selectUserProgress);
  const previousScore = usePreviousPersistent(score);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        duration: 1,
      }}
      className="flex bg-indigo-500 h-full flex-col font-bold rounded-sm"
    >
      <div className="flex-grow px-4 border-b flex items-center ">
        <div>
          <span className="text-xl">Cəhd sayı</span>
        </div>
        <motion.ul
          variants={gridContainerVariants}
          initial="hidden"
          animate="visible"
          className="flex justify-end flex-grow gap-4"
        >
          {Array(health)
            .fill(0)
            .map((_, index) => (
              <motion.li variants={gridSlotVariants} key={index}>
                <BoltIcon
                  key={index}
                  className=" transition-all duration-500 ease-in-out"
                  style={{
                    fill: index < remainingHealth ? "yellow" : "transparent",
                    width: "36px",
                    height: "36px",
                  }}
                />
              </motion.li>
            ))
            .toReversed()}
        </motion.ul>
      </div>

      <div className="flex-grow px-4 flex items-center">
        <div>
          <span className="text-xl">Nəticə</span>
        </div>

        <div className="flex-grow flex justify-end">
          <span className="text-2xl  text-yellow-400">
            <CountUp start={previousScore} end={score} duration={3} />
          </span>
        </div>
      </div>
    </motion.div>
  );
}
